var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-entry-shell",staticStyle:{"height":"100% !important"}},[(!_vm.isMobileCartEntry)?_c('cart-entry-desktop'):_c('cart-entry-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }